import styled from 'styled-components'
import { designLayoutSize } from '@/utils/export-pptx/constants'

const Wrapper = styled.div`
  position: relative;
  width: ${designLayoutSize.w}px;
  height: ${designLayoutSize.h}px;

  color: ${({ theme }): string => theme.colors.text.primary};
  background-color: ${({ theme }): string => theme.colors.background.grey};
  font-family: Arial;

  &,
  * {
    box-sizing: border-box;
  }
`

const SlideContainer = styled(Wrapper)`
  padding: 48px 64px;
`

const SlideTitle = styled.div<{ mb?: number }>`
  display: flex;
  align-items: center;
  gap: 16px;

  margin-bottom: ${({ mb }): number => (mb ?? 6) * 8}px;

  color: ${({ theme }): string => theme.colors.text.primary};
  background-color: ${({ theme }): string => theme.colors.background.grey};
  font-size: 42px;
  font-weight: 700;
`

const PostList = styled.div`
  position: relative;
`

const PostListItem = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  padding: 16px 0;

  background: #fff;
  width: 100%;
`

const PostListItemBorderBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 1px;

  background-color: ${({ theme }): string => theme.colors.background.grey};
`

const PostImage = styled.img`
  flex-shrink: 0;

  width: 88px;
  height: 60px;

  border-radius: 4px;
  overflow: hidden;
  object-fit: cover;

  background-color: ${({ theme }): string => theme.colors.background.grey};
`

const PostInfo = styled.div`
  flex-grow: 1;
  min-width: 0;
`

const PostContent = styled.p`
  margin-bottom: 8px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  color: ${({ theme }): string => theme.colors.text.primary};
`

const KolAvatar = styled.img`
  flex-shrink: 0;

  display: inline-block;
  margin-right: 8px;

  width: 24px;
  height: 24px;
  border-radius: 50%;

  overflow: hidden;
  background-color: ${({ theme }): string => theme.colors.background.grey};
`

const KolName = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }): string => theme.colors.text.secondary};
`

const PostValue = styled.span`
  margin-left: 8px;

  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }): string => theme.colors.text.primary};
`

const PostValueLabel = styled.span`
  position: absolute;
  right: 0;
  top: -16px;

  font-size: 12px;
  color: ${({ theme }): string => theme.colors.text.secondary};
`

const PostRank = styled.span`
  margin-right: 8px;

  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }): string => theme.colors.text.primary};
`

const Card = styled.div`
  width: 100%;
  min-width: 0;

  padding: 24px 40px;

  border-radius: 4px;
  background: ${({ theme }): string => theme.colors.text.white};
`

const CardTitle = styled.p<{ mb?: number }>`
  margin-bottom: ${({ mb }): number => (mb ?? 3) * 8}px;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  color: ${({ theme }): string => theme.colors.text.primary};
`

export {
  PostValue,
  PostValueLabel,
  Card,
  CardTitle,
  KolAvatar,
  PostList,
  PostListItem,
  PostListItemBorderBottom,
  KolName,
  PostInfo,
  PostImage,
  PostContent,
  PostRank,
  SlideContainer,
  SlideTitle,
  Wrapper,
}
